import React from 'react';
import { observer } from 'mobx-react';
import { ReturnAddressEdit } from 'modules/return-address/pages';
import { defaultTemplate } from 'core/hoc';
import {
	Loader,
	BaasicHeader,
	BaasicSelect,
	BaasicInput,
	BaasicTextArea,
	BaasicDropdown,
	BaasicModal,
} from 'core/components';
import _ from 'lodash';
import ReactTooltip from 'react-tooltip';
import SelectSkuQuantityTemplate from './SelectSkuQuantityTemplate';

const ReturnLabelTemplate = ({
	t,
	returnLabelViewStore,
	returnLabelViewStore: {
		form,
		isFormValid,
		loading,
		onCarrierServiceSelect,
		onReturnReasonSelect,
		carrierServiceOptions,
		handleOnCarrierServiceMenuScroll,
		onMenuCloseCarrier,
		debouncedCarrierServiceSearch,
		isCarrierServiceLoading,
		returnReasonOptions,
		selectedReturnReason,
		rootStore,
		selectedOrder,
		boxForm,
		isBoxRequired,
		noRatesMessage,
		onePerBoxMessage,
		editModal,
		returnAddressDropDownStore,
		onAddressDataChange,
	},
}) => {
	if (loading) return <Loader />;
	return (
		<React.Fragment>
			<BaasicModal modalParams={editModal}>
				<ReturnAddressEdit parentViewStore={returnLabelViewStore} />
			</BaasicModal>
			<div className="order">
				<BaasicHeader title="Return Label" rootStore={rootStore}></BaasicHeader>
				<div className="container container--lrg container--footer">
					<div>
						<SelectSkuQuantityTemplate
							t={t}
							viewStore={returnLabelViewStore}
							additionalDisableCheck={isCarrierServiceLoading}
							productsForSelection={selectedOrder.orderLines}
							onePerBoxInputDisable={true}
							title={'ORDERVIEW.RETURNLABELVIEW.SELECTITEMS'}
							warningMessage={onePerBoxMessage}
						/>

						{/* Box Dropdown */}
						{isBoxRequired && <BoxSelection returnLabelViewStore={returnLabelViewStore} t={t} />}

						<form onSubmit={form.onSubmit}>
							{(isBoxRequired ? boxForm.$('box').value && boxForm.$('box').value.label !== 'Add new template' : true) &&
								selectedOrder.orderLines.some(i => i.isChecked || i.isPartiallyChecked) && (
									<React.Fragment>
										<div className="spc--bottom--med"></div>
										<div className="row row--form">
											<div className="col col-sml-12 col-lrg-6">
												<BaasicInput
													field={form.$('buyerName')}
													className="fs-mask"
													onKeyUp={() => onAddressDataChange()}
												/>
											</div>
											<div className="col col-sml-12 col-lrg-6">
												<BaasicInput field={form.$('phone1')} onKeyUp={() => onAddressDataChange()} />
											</div>
											<div className="col col-sml-12 col-lrg-6">
												<BaasicInput field={form.$('address1')} onKeyUp={() => onAddressDataChange()} />
											</div>
											<div className="col col-sml-12 col-lrg-6">
												<BaasicInput field={form.$('address2')} />
											</div>
											<div className="col col-sml-12 col-lrg-6">
												<BaasicInput field={form.$('address3')} />
											</div>
											<div className="col col-sml-12 col-lrg-6">
												<BaasicInput field={form.$('city')} onKeyUp={() => onAddressDataChange()} />
											</div>
											<div className="col col-sml-12 col-lrg-6">
												<BaasicInput field={form.$('zipCode')} onKeyUp={() => onAddressDataChange()} />
											</div>
											<div className="col col-sml-12 col-lrg-6">
												<BaasicInput field={form.$('countryStateCode')} onKeyUp={() => onAddressDataChange()} />
											</div>
											<div className="col col-sml-12 col-lrg-6">
												<BaasicInput field={form.$('countryCode')} onKeyUp={() => onAddressDataChange()} />
											</div>
											<div className="col col-sml-12 col-lrg-6 spc--bottom--sml">
												<BaasicSelect
													field={form.$('returnReasonId')}
													clearable={false}
													onChange={onReturnReasonSelect}
													options={returnReasonOptions.slice()}
													value={selectedReturnReason}
													disabled={loading}
												/>
											</div>
											<div className="col col-sml-12 col-lrg-6 spc--bottom--sml">
												<div className="row row--form">
													<div className="col col-sml-12 col-lrg-8">
														<BaasicDropdown dropdownStore={returnAddressDropDownStore} />
													</div>
													<div className="col col-sml-12 col-lrg-4">
														<button
															className="btn btn--med btn--primary"
															onClick={() => editModal.open()}
															type="button"
														>
															<i className="fa fa-plus spc--right--sml"></i>
															{t('RETURNADDRESSVIEW.ADDRETURNADDRESS')}
														</button>
													</div>
												</div>
											</div>
											<div className="col col-sml-12 col-lrg-6 spc--bottom--sml">
												<BaasicSelect
													field={form.$('carrierService')}
													options={carrierServiceOptions.slice()}
													onChange={onCarrierServiceSelect}
													value={form.$('carrierService').value}
													disabled={isCarrierServiceLoading || !form.isValid}
													onMenuScrollToBottom={handleOnCarrierServiceMenuScroll}
													isLoading={isCarrierServiceLoading}
													onMenuClose={onMenuCloseCarrier}
													onInputChange={debouncedCarrierServiceSearch}
													useCustomOption={true}
												/>
											</div>
											{noRatesMessage && (
												<React.Fragment>
													<div className="col col-sml-12 col-lrg-6"></div>
													<div className="col col-sml-12 col-lrg-6 spc--bottom--sml">
														<p className="type--color--warning">{t(noRatesMessage)}</p>{' '}
													</div>
												</React.Fragment>
											)}
											<div className="col col-sml-12">
												<BaasicTextArea field={form.$('internalNote')} />
											</div>
										</div>
									</React.Fragment>
								)}
							<div className="container__footer type--right">
								<button
									className="btn btn--med btn--success spc--right--sml spc--bottom--sml"
									type="submit"
									disabled={
										loading ||
										!isFormValid ||
										isCarrierServiceLoading ||
										!selectedOrder.orderLines.some(i => i.isChecked || i.isPartiallyChecked) ||
										noRatesMessage
									}
								>
									{loading && !isCarrierServiceLoading ? (
										<div className="spinnercont spc--right--sml">
											<div className="spinner"></div>
										</div>
									) : null}
									{t('ORDERVIEW.RETURNLABELVIEW.CREATE')}
								</button>
							</div>
						</form>
					</div>
				</div>
			</div>
			<ReactTooltip />
		</React.Fragment>
	);
};

export default defaultTemplate(ReturnLabelTemplate);

const BoxSelection = observer(
	({
		t,
		returnLabelViewStore: {
			boxOptions,
			handleOnBoxMenuScroll,
			isBoxDropdownLoading,
			onMenuClose,
			showCreateTemplate,
			onCreateTemplateCancel,
			onBoxChange,
			boxForm,
			debouncedBoxSearch,
			isBoxRequired,
		},
	}) => {
		return (
			<div>
				<div className="row">
					<div className="col col-sml-12 col-med-6 spc--bottom--med">
						<BaasicSelect
							field={boxForm.$('box')}
							isClearable={true}
							options={boxOptions.slice()}
							value={boxForm.$('box').value}
							onChange={value => onBoxChange(value, boxForm.$('box'))}
							onMenuScrollToBottom={handleOnBoxMenuScroll}
							onInputChange={debouncedBoxSearch}
							isLoading={isBoxDropdownLoading}
							onMenuClose={onMenuClose}
							className="flex--grow--1"
							useCustomOption={true}
							isAddTemplate={true}
							disabled={!isBoxRequired}
							placeholder={isBoxRequired ? undefined : t('ORDERVIEW.RETURNLABELVIEW.BOXNOTREQUIRED')}
						/>
					</div>
				</div>

				{showCreateTemplate && (
					<form className="box--primary box--sml" onSubmit={boxForm.onSubmit}>
						<div className="box__header">
							<h4 className="type--base type--color--grey-5">
								{t('ORDERVIEW.RETURNLABELVIEW.BOX.CREATEDIMENSIONSTEMPLATE')}
							</h4>
						</div>
						<div className="row row--form">
							<div className="col col-sml-12 col-med-6 col-lrg-3">
								<BaasicInput field={boxForm.$('name')} placeholder={t('ORDERVIEW.RETURNLABELVIEW.BOX.NAME')} />
							</div>
							<div className="col col-sml-12 col-med-6 col-lrg-3">
								<BaasicInput field={boxForm.$('boxHeight')} placeholder={t('ORDERVIEW.RETURNLABELVIEW.BOX.HEIGHT')} />
							</div>
							<div className="col col-sml-12 col-med-6 col-lrg-3">
								<BaasicInput field={boxForm.$('boxWidth')} placeholder={t('ORDERVIEW.RETURNLABELVIEW.BOX.WIDTH')} />
							</div>
							<div className="col col-sml-12 col-med-6 col-lrg-3">
								<BaasicInput field={boxForm.$('boxLength')} placeholder={t('ORDERVIEW.RETURNLABELVIEW.BOX.LENGTH')} />
							</div>
						</div>
						<div>
							<button className="btn btn--sml btn--primary spc--right--sml" type="submit">
								{t('ORDERVIEW.RETURNLABELVIEW.BOX.CREATE')}
							</button>
							<button className="btn btn--sml btn--outline" type="button" onClick={() => onCreateTemplateCancel()}>
								{t('ORDERVIEW.RETURNLABELVIEW.BOX.CANCEL')}
							</button>
						</div>
					</form>
				)}
			</div>
		);
	}
);



// WEBPACK FOOTER //
// ./src/themes/default/modules/order/pages/ReturnLabelTemplate.jsx